/**
 * Request Correspondence (GitLab #1069) — public surface of the feature.
 *
 * Explicit exports rather than `export *`. The domain types are named
 * `Message`, `Thread` and `SpaceId`, which are generic enough to collide with
 * anything; re-exporting them from a component barrel would put them one
 * `import { Message }` away from every screen in the app. Consumers that
 * genuinely need them import from `./correspondence.types` directly.
 *
 * See `_bmad-output/planning-artifacts/prd.md` and
 * `_bmad-output/planning-artifacts/state-of-play-1069.md`.
 */
export { CorrespondencePanel } from './CorrespondencePanel';
export { CorrespondenceLauncher } from './CorrespondenceLauncher';
export { CorrespondenceDock } from './CorrespondenceDock';
/**
 * The toolbar toggle (Story 1.2, C2). Rendered by the SCREEN inside
 * `RequestToolbar.actionTrailing`; the launcher above is the overlay host only.
 */
export { DiscussionToggle } from './DiscussionToggle';
/**
 * The request-list row marker (Story 2.2, FR53). A `MessageSquare` glyph with an
 * in-flow dot.
 *
 * Given `onPress` it is a BUTTON that opens the request with its discussion
 * showing, and the caller MUST stop the press reaching the row (owner change
 * 2026-09-11; `discussionEntry.ts`). `ViewRequests` always passes it. Without
 * `onPress` it is a status image the row's own label includes, which is what
 * Story 2.2's D5 originally specified and what any surface with nowhere to go
 * still gets.
 */
export { DiscussionRowIndicator } from './DiscussionRowIndicator';
/**
 * Arriving at a request with the discussion open (owner change 2026-09-11):
 * the list builds the path, the request screen reads the flag, one contract.
 */
export {
  DISCUSSION_QUERY_PARAM,
  arrivesWithDiscussionOpen,
  requestDetailPathWithDiscussion,
} from './discussionEntry';
/**
 * The one place the server's unread answer and the panel's own are reconciled
 * (#1069 P3.3). Exported because the SCREEN owns it: the launcher pill and the
 * docked panel are siblings, so neither can hold it for the other.
 */
export { useUnreadSpaceState } from './useUnreadSpaceState';
/**
 * The panel's session, owned by the request screen so a resize or a close
 * never loses the user's place (2026-09-25; replaced `useCloseOnUndock`).
 */
export {
  useCorrespondenceSessionFor,
  type CorrespondenceSession,
} from './correspondenceSession';
export {
  DOCK_CONTENT_FLOOR,
  DOCK_MIN_VIEWPORT_WIDTH,
  DOCK_PANEL_WIDTH,
  shouldDock,
} from './dockLayout';
